module.exports = "https://cdn.redage.net/src/views/player/documets/images/male.png";